import AbstractTab from "./AbstractTab";

export default class PlantsTab extends AbstractTab {
    name = 'plants';
    tooltip = 'Plants (P)';
    icon = '<svg class="icon"><use xlink:href="/icons/__remixicon.sprite.svg#plant-line"></use></svg>';

    constructor(provider, tabContainer) {
        super(provider);

        this.plantOverview = this.p.createDiv()
            .parent(tabContainer)
            .class("planner-aside-wrapper");

        let plantLabel = this.p.createElement('H3', 'Plants in this plan')
            .parent(this.plantOverview)
            .class('mar-t-0 mar-b');

        this.rowContainer = this.p.createDiv().parent(this.plantOverview)
            .class('pad-b');

        this.plantOverview.hide();

        this.resizeWindow();
    }

    positionPlantOverview() {
        // this.plantOverview.position(this.sideBar.x, 0);
    }

    resizeWindow() {
        // this.positionPlantOverview();
    }

    activate() {
        // this.button.addClass('-is-active');
        this.plantOverview.show();
    }

    deactivate() {
        // this.button.removeClass('-is-active');
        this.plantOverview.hide();
    }
}
